import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { useSelector } from "react-redux";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import StaticPagesService from "../../../services/StaticPagesService";
import { Translate } from "../../Enums/Tranlate";
import htmlToDraft from "html-to-draftjs";
import BaseService from "../../../services/BaseService";

const Static = () => {
	const initial = {
		title: EditorState.createEmpty(),
		title_ar: EditorState.createEmpty(),
		description: EditorState.createEmpty(),
		description_ar: EditorState.createEmpty(),
		image: "",
	};
	const [formData, setFormData] = useState(initial);
	const [about, setAbout] = useState([
		{
			title_en: EditorState.createEmpty(),
			title_ar: EditorState.createEmpty(),
			description_en: EditorState.createEmpty(),
			description_ar: EditorState.createEmpty(),
			image: "",
		},
	]);
	const [submitLoading, setSubmitLoading] = useState(false);
	const [loading, setLoading] = useState(false);
	const [type, setType] = useState("about");
	const lang = useSelector((state) => state.auth?.lang);
	const staticService = new StaticPagesService();

	useEffect(() => {
		if (type !== "about") {
			staticService.getList({ type: type }).then((res) => {
				if (res?.status) {
					let response = res?.data?.data[0];
					setFormData({
						description: EditorState.createWithContent(
							ContentState.createFromBlockArray(
								htmlToDraft(response?.description_en?.replaceAll("&lt;", "<"))
							)
						),
						description_ar: EditorState.createWithContent(
							ContentState.createFromBlockArray(
								htmlToDraft(response?.description_ar?.replaceAll("&lt;", "<"))
							)
						),
					});
				}
			});
		} else {
			staticService.getAbout().then((res) => {
				if (res?.status) {
					let response = res?.data?.data;
					setFormData({
						description: EditorState.createWithContent(
							ContentState.createFromBlockArray(
								htmlToDraft(response?.description_en?.replaceAll("&lt;", "<"))
							)
						),
						description_ar: EditorState.createWithContent(
							ContentState.createFromBlockArray(
								htmlToDraft(response?.description_ar?.replaceAll("&lt;", "<"))
							)
						),
					});
					let aboutData = response?.about_us_values?.map((us) => {
						return {
							title_en: EditorState.createWithContent(
								ContentState.createFromBlockArray(htmlToDraft(us?.title_en))
							),
							title_ar: EditorState.createWithContent(
								ContentState.createFromBlockArray(htmlToDraft(us?.title_ar))
							),
							description_en: EditorState.createWithContent(
								ContentState.createFromBlockArray(
									htmlToDraft(us?.description_en)
								)
							),
							description_ar: EditorState.createWithContent(
								ContentState.createFromBlockArray(
									htmlToDraft(us?.description_ar)
								)
							),
							image: us?.image,
						};
					});
					setAbout(aboutData);
				}
			});
		}
	}, [type]);

	const onSubmit = (e) => {
		e.preventDefault();

		let info = {
			type: type,
			static_page: [
				{
					description_ar: draftToHtml(
						convertToRaw(formData?.description_ar.getCurrentContent())
					),
					description_en: draftToHtml(
						convertToRaw(formData?.description.getCurrentContent())
					),
				},
			],
		};

		setSubmitLoading(true);
		staticService.create(info).then((response) => {
			if (response?.status === 201) {
				toast.success(response?.data?.message);
			}
			setSubmitLoading(false);
		});
	};

	const aboutSubmit = (e) => {
		e.preventDefault();

		let info = {
			description_ar: draftToHtml(
				convertToRaw(formData?.description_ar.getCurrentContent())
			),
			description_en: draftToHtml(
				convertToRaw(formData?.description.getCurrentContent())
			),
			about_us_value: about?.map((res) => {
				return {
					image: res?.image,
					title_en: draftToHtml(
						convertToRaw(res?.title_en.getCurrentContent())
					),
					title_ar: draftToHtml(
						convertToRaw(res?.title_ar.getCurrentContent())
					),
					description_en: draftToHtml(
						convertToRaw(res?.description_en.getCurrentContent())
					),
					description_ar: draftToHtml(
						convertToRaw(res?.description_ar.getCurrentContent())
					),
				};
			}),
		};

		setSubmitLoading(true);
		staticService.createAbout(info).then((response) => {
			if (response?.status === 201) {
				toast.success(response?.data?.message);
			}
			setSubmitLoading(false);
		});
	};

	const fileHandler = (e, index) => {
		let files = e.target.files;
		const filesData = Object.values(files);
		setLoading(true);

		if (filesData?.length) {
			new BaseService()
				.postUpload(filesData[0])
				.then((res) => {
					if (res?.status === 200) {
						setAbout((prev) =>
							prev?.map((item, ind) =>
								index === ind ? { ...item, image: res?.data?.url } : item
							)
						);
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<div className="department">
			<div className="tabs-div">
				{["about", "terms", "privacy"].map((tab) => (
					<p
						onClick={() => {
							setType(tab);
						}}
						className={type === tab ? "activeP" : ""}>
						{Translate[lang][tab]}
					</p>
				))}
			</div>
			<div className="mt-5 mb-4">
				<span
					style={{
						fontWeight: "600",
						textTransform: "capitalize",
						color: "#000",
						fontSize: "26px",
					}}>
					{Translate[lang][type]}
				</span>
			</div>
			<Row className="about">
				<Col md={10}>
					<AvForm onValidSubmit={type === "about" ? aboutSubmit : onSubmit}>
						<div className="row">
							<div className="col-lg-12 col-sm-12 mb-3">
								<label>{Translate[lang].english_description}</label>
								<Editor
									editorState={formData.description}
									toolbarClassName="toolbarClassName"
									wrapperClassName="wrapperClassName"
									editorClassName="editorClassName"
									onEditorStateChange={(e) =>
										setFormData({ ...formData, description: e })
									}
								/>
							</div>
							<div className="col-lg-12 col-sm-12 mb-3">
								<label>{Translate[lang].arabic_description}</label>
								<Editor
									editorState={formData.description_ar}
									toolbarClassName="toolbarClassName"
									wrapperClassName="wrapperClassName"
									editorClassName="editorClassName"
									onEditorStateChange={(e) =>
										setFormData({ ...formData, description_ar: e })
									}
								/>
							</div>
							{type === "about" && <div className="col-12 mb-5"></div>}
							{type === "about" &&
								about?.map((res, index) => (
									<React.Fragment key={index}>
										<Col lg={12} md={12} className="mt-3 mb-2">
											<hr />
										</Col>
										<Col lg={12} md={12} className="mb-2">
											{index + 1})
										</Col>
										<Col lg={6} md={6} className="mb-3">
											<label>{Translate[lang].english_title}</label>
											<Editor
												editorState={res?.title_en}
												toolbarClassName="toolbarClassName"
												wrapperClassName="wrapperClassName"
												editorClassName="editorClassName"
												onEditorStateChange={(e) =>
													setAbout((prev) =>
														prev?.map((item, ind) =>
															ind === index ? { ...item, title_en: e } : item
														)
													)
												}
											/>
										</Col>
										<Col lg={6} md={6} className="mb-3">
											<label>{Translate[lang].arabic_title}</label>
											<Editor
												editorState={res?.title_ar}
												toolbarClassName="toolbarClassName"
												wrapperClassName="wrapperClassName"
												editorClassName="editorClassName"
												onEditorStateChange={(e) =>
													setAbout((prev) =>
														prev?.map((item, ind) =>
															ind === index ? { ...item, title_ar: e } : item
														)
													)
												}
											/>
										</Col>
										<Col lg={6} md={6} className="mb-3">
											<label>{Translate[lang].english_description}</label>
											<Editor
												editorState={res?.description_en}
												toolbarClassName="toolbarClassName"
												wrapperClassName="wrapperClassName"
												editorClassName="editorClassName"
												onEditorStateChange={(e) =>
													setAbout((prev) =>
														prev?.map((item, ind) =>
															ind === index
																? { ...item, description_en: e }
																: item
														)
													)
												}
											/>
										</Col>
										<Col lg={6} md={6} className="mb-3">
											<label>{Translate[lang].arabic_description}</label>
											<Editor
												editorState={res?.description_ar}
												toolbarClassName="toolbarClassName"
												wrapperClassName="wrapperClassName"
												editorClassName="editorClassName"
												onEditorStateChange={(e) =>
													setAbout((prev) =>
														prev?.map((item, ind) =>
															ind === index
																? { ...item, description_ar: e }
																: item
														)
													)
												}
											/>
										</Col>
										<Col md={6}>
											<label className="text-label mb-0">
												{Translate[lang].image}
											</label>
											<div className="upload">
												<input
													type="file"
													name="image"
													id="image"
													onChange={(e) => fileHandler(e, index)}
												/>
												<p>{Translate[lang].upload_image}</p>
												{!res?.image ? (
													<svg
														width="24"
														height="24"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg">
														<path
															d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
															stroke="#0F50A6"
															strokeWidth="1.5"
															strokeLinecap="round"
															strokeLinejoin="round"
														/>
														<path
															d="M12 15V3.62"
															stroke="#0F50A6"
															strokeWidth="1.5"
															strokeLinecap="round"
															strokeLinejoin="round"
														/>
														<path
															d="M15.35 5.85L12 2.5L8.65002 5.85"
															stroke="#0F50A6"
															strokeWidth="1.5"
															strokeLinecap="round"
															strokeLinejoin="round"
														/>
													</svg>
												) : (
													<svg
														width="24"
														height="24"
														viewBox="0 0 16 16"
														fill="none"
														xmlns="http://www.w3.org/2000/svg">
														<path
															d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
															fill="#21AA37"
														/>
													</svg>
												)}
											</div>
											{!!res?.image && (
												<img
													src={res?.image}
													alt={`about_image${index}`}
													width={80}
													className="mt-3"
												/>
											)}
										</Col>
										{about?.length - 1 === index && (
											<Col lg={12} md={12} className="mt-3">
												<Button
													variant="outline-primary"
													className="w-50"
													onClick={() =>
														setAbout((prev) => [
															...prev,
															{
																title_en: "",
																title_ar: "",
																description_en: "",
																description_ar: "",
																image: "",
															},
														])
													}>
													{Translate[lang].add_new_value}
												</Button>
											</Col>
										)}
									</React.Fragment>
								))}

							<div className="col-lg-12 col-sm-12 mt-5 mb-5">
								<Button
									variant="primary"
									type="submit"
									className="w-50 fs-14"
									disabled={submitLoading}>
									{Translate[lang]?.save}
								</Button>
							</div>
						</div>
					</AvForm>
				</Col>
			</Row>
		</div>
	);
};

export default Static;
